<template lang="pug">
div
    h5.over-title.margin-bottom-15
        | Пока 
        span.text-bold не платят ({{ notPayedCompaniesCount }})
    p
        strong Компаний на тестовом периоде: 
        | {{ trialCompaniesNowCount }}
    .panel-body.table-responsive.border-none
        table.table.table-hover.table-striped
            thead
                tr
                    th.center.hidden-xs #
                    th Магазины
                    th Доступ до
                    th Контакт
                    th Статус
                    th CMS
            tbody
                template(v-for='(company, index) in notPayedCompanies')
                    tr
                        td.center.hidden-xs {{ 1 + index + (page - 1)*perPage }}
                        td 
                            a.grey(target='_blank' :href='company.domains[0]') {{ company.domains[0].toLowerCase().trim() | extractHostname }}
                            a.pull-right(@click.prevent='changeCompany(company.company_id)') 
                                i.fa.fa-sign-in

                            template(v-if="company.domains.length > 1 && showAllDomainCompanies.indexOf(company.company_id) == -1")
                                a.grey(@click.prevent='showAllDomains(company.company_id)') ...

                            template(v-for='(domain, domain_index) in company.domains')
                                a.grey(v-if="domain_index > 0 && showAllDomainCompanies.indexOf(company.company_id) > -1" target='_blank' style='display: block' :href='domain') {{ domain.toLowerCase().trim() | extractHostname }}

                        td {{ company.payed_to }}
                        td
                            a.grey(@click.prevent='toggleContact(company.company_id)' style='border-bottom: 1px dashed rgba(91, 91, 96, 0.52);') {{ company.client_name }}
                            template(v-if='showingContactCompanies.indexOf(company.company_id) > -1') <br /> {{ company.email }} <br /> {{ company.phone }}
                        td
                            template(v-if='company.payed')
                                span(class='label label-danger') платил
                            template(v-else-if="company.in_trial")
                                span.label.label-success trial
                            template(v-else) &mdash;
                        td
                            template(v-if='company.cms_list') {{ company.cms_list }}
                            template(v-else) ?

        ul.pagination(v-if='pages > 1')
            li(v-for='n in pages' :class='{"active": page == n}')
                a(@click='goToPage(n)')
                    span {{ n }}
</template>

<script>
import { mapActions } from 'vuex';

import ajaxRequest from '@/utils/request';
import {arrayRemove} from '@/utils/helpers';

export default {
    name: 'Finance',
    created() {
        this.getNotPayedCompanies();
    },
    props: {
        search: String
    },
    watch: {
        search(value) {
            this.getNotPayedCompanies();
        }
    },
    methods: {
        ...mapActions(['changeCompany']),
        getNotPayedCompanies() {
            let me = this;
            ajaxRequest({
                url: `/payments/not_paying_companies?page=${me.page}&limit=${me.perPage}&query=${me.search}`,
                success(response) {
                    me.notPayedCompanies = response.not_paying_companies;
                    me.notPayedCompaniesCount = response.not_paying_companies_count;
                    me.trialCompaniesNowCount = response.trial_companies_now_count;
                    me.pages = Math.ceil(me.notPayedCompaniesCount / me.perPage);
                }
            });
        },
        showAllDomains(company_id) {
            // Показывает все домены компании, не только первый магазин
            this.showAllDomainCompanies.push(company_id);
        },
        toggleContact(company_id) {
            if (this.showingContactCompanies.indexOf(company_id) > -1) {
                this.showingContactCompanies = arrayRemove(this.showingContactCompanies, company_id);
            } else {
                this.showingContactCompanies.push(company_id);
            }
        },
        goToPage(page) {
            this.page = page;
            this.getNotPayedCompanies();
        }
    },
    data() {
        return {
            showAllDomainCompanies: [],
            showingContactCompanies: [],
            notPayedCompanies: [],
            notPayedCompaniesCount: 0,
            trialCompaniesNowCount: 0,
            page: 1,
            perPage: 10,
            pages: 1
        };
    }
};
</script>

<style>
.border-none {
    border: none;
}
.payment-expired {
    color: red !important;
}
a.grey {
    color: #5b5b60 !important;
}
p  strong {
    color: #8e8e93
}
</style>



// WEBPACK FOOTER //
// src/components/finance/NotPayingCompanies.vue